import { nav } from "./nav";
import { hero } from "./hero";
import { dashboard } from "./dashboard";
import { faq } from "./faq";
import { footer } from "./footer";
import { pricing } from "./pricing";
import { howItWorks } from "./howItWorks";
import { favorites } from "./favorites";
import { memberProfile } from "./memberProfile";
import { incomingRequests } from "./incomingRequests";
import { migrated } from "./migrated";
import { countries } from "./countries";

export const common = {
  nav,
  hero,
  dashboard,
  faq,
  footer,
  pricing,
  howItWorks,
  favorites,
  memberProfile,
  incomingRequests,
  migrated,
  countries,
  corporate: {
    hero: {
      title: "Επανεφεύρεση του ταξιδιού",
      subtitle:
        "Μια ηθική, τοπική και ανθρώπινη όραση για τον τουρισμό του μέλλοντος.",
    },
    mission: {
      badge: "Η Αποστολή μας",
      title: "Δίκαιος τουρισμός",
      description:
        "Πιστεύουμε ότι το ταξίδι πρέπει να είναι προσβάσιμο σε όλους, χωρίς δαπανηρούς μεσάζοντες. Το DONKEY TRAVEL επιτρέπει στους ιδιοκτήτες να ταξιδεύουν ελεύθερα χάρη στην αξία της δικής τους ιδιοκτησίας.",
    },
    philosophy: {
      badge: "Η Φιλοσοφία μας",
      title: "Κατασκευασμένο στη Γαλλία & Ανθρώπινο",
      description:
        "Ριζωμένοι στην κοιλάδα της Σομ, υπερασπιζόμαστε ένα βιοτεχνικό μοντέλο έναντι των γιγάντων της τεχνολογίας. Χωρίς σκοτεινούς αλγόριθμους, μόνο κοινή λογική και κοινωνικότητα.",
      values: {
        fair: {
          title: "Δίκαιο",
          desc: "0% προμήθεια στις ανταλλαγές. Μόνο μια διαφανής συνδρομή.",
        },
        local: {
          title: "Τοπική Ρίζωση",
          desc: "Περήφανοι για τις γαλλικές μας ρίζες, προωθούμε έναν σεβαστό τουρισμό.",
        },
        community: {
          title: "Κοινότητα",
          desc: "Ένας ιδιωτικός σύλλογος αξιόπιστων ιδιοκτητών που μοιράζονται τις ίδιες αξίες.",
        },
      },
    },
    team: {
      badge: "Η ομάδα",
      title: "Παθιασμένοι στην υπηρεσία σας",
      subtitle:
        "Πίσω από την πλατφόρμα, άνθρωποι που αγαπούν να ταξιδεύουν και να μοιράζονται.",
      members: {
        ceo: {
          name: "Plük",
          role: "Δημιουργός του DONKEY TRAVEL • Προγραμματιστής • Airbnb Superhost για 4 χρόνια",
          bio: "Για χρόνια φιλοξενούσα ταξιδιώτες στα καταλύματά μου, στα οποία θα μπορούσα και εγώ ο ίδιος να είχα πάει αν υπήρχε το TRAVELTROK. Γι' αυτό δημιούργησα το DONKEY TRAVEL: για να μπορούν οι οικοδεσπότες να φιλοξενούν ο ένας τον άλλο και να ταξιδεύουν διαφορετικά.",
        },
        cto: {
          name: "Marie Martin",
          role: "CTO",
          bio: "Αρχιτέκτονας πλατφόρμας, φύλακας ασφαλείας.",
        },
        cmo: {
          name: "Sophie Bernard",
          role: "Υπεύθυνη Επικοινωνίας",
          bio: "Η φωνή του DONKEY TRAVEL στην κοινότητά μας.",
        },
      },
    },
    investors: {
      badge: "Επενδυτές",
      title: "Ελάτε στην περιπέτεια",
      description:
        "Το DONKEY TRAVEL βρίσκεται σε πλήρη ανάπτυξη. Αναζητάμε εταίρους που μοιράζονται το όραμά μας για έναν βιώσιμο και δίκαιο τουρισμό.",
      cta: "Επικοινωνήστε μαζί μας για επενδύσεις",
    },
  },
  trokOrigin: {
    badge: "Κατανοώντας την ιδέα",
    title: "Τι ακριβώς είναι το Τροκ;",
    subtitle:
      "Μια άμεση ανταλλαγή μεταξύ δύο ατόμων, χωρίς μεσάζοντες ή περίπλοκα συστήματα πόντων",
    etymology: {
      title: "Η προέλευση της λέξης",
      historicalTitle: "Μια πρακτική χιλιετιών",
      text1:
        'Η λέξη "Τροκ" εμφανίζεται στα γαλλικά τον 14ο αιώνα, παράγωγο του ρήματος "troquer". Βρίσκει τις ρίζες της στο ισπανικό "trucque" και το βαλλωνικό "trouk", υποδηλώνοντας την ιδέα της άμεσης ανταλλαγής.',
      text2:
        'Μαρτυρείται ήδη από το 1364 με τη μορφή "truke" σε αγγλο-νορμανδικά έγγραφα, και στη συνέχεια επισημοποιήθηκε το 1464 σε επιστολές του Λουδοβίκου ΙΑ\': "για την πώληση, τροκ ή ανταλλαγή αυτών των εμπορευμάτων".',
      text3:
        "Στο DONKEY TRAVEL, κρατήσαμε αυτή την προγονική φιλοσοφία: ανταλλάσσετε απευθείας το σπίτι σας με έναν άλλο ιδιοκτήτη. Όχι εικονικό νόμισμα, όχι πόντοι. Απλά μια συμφωνία μεταξύ δύο ανθρώπων.",
      from: "Ετυμολογία",
      meaning: "Ανταλλαγή απευθείας, από άτομο σε άτομο",
      century14: "14ος αιώνας",
      firstAttestation: "Πρώτη μαρτυρία στα γαλλικά",
      century15: "15ος αιώνας",
      officialUse: "Επίσημη χρήση από Λουδοβίκο ΙΑ'",
      today: "Σήμερα",
      modernPractice: "Σύγχρονη και συνεργατική πρακτική",
    },
    direct: {
      title: "Μόνο άμεση ανταλλαγή",
      description:
        "Σε αντίθεση με τα συστήματα πόντων, το DONKEY TRAVEL λειτουργεί με την αρχή της καθαρής ανταλλαγής. Διαπραγματεύεστε απευθείας: οι νύχτες σας έναντι των δικών του. Είναι η ουσία της ανταλλαγής όπως υπάρχει από τον 14ο αιώνα.",
      result: "Άμεση ανταλλαγή επικυρωμένη!",
    },
    noTriangulation: {
      title: "Όχι τριγωνική ανταλλαγή",
      description:
        "Όχι περίπλοκα συστήματα όπου ο Α δίνει στον Β που δίνει στον Γ. Εδώ είναι απλά: βρίσκετε κάποιον, διαπραγματεύεστε (ταυτόχρονες ή ετεροχρονισμένες ημερομηνίες), ανταλλάσσετε. Τελεία.",
      noPoints: "Όχι πόντοι για μέτρημα",
    },
    meetHost: {
      title: "Γνωρίστε έναν άλλο οικοδεσπότη Airbnb",
      description:
        "Το DONKEY TRAVEL δεν είναι μόνο ανακάλυψη σπιτιού ή ταξίδι. Είναι κυρίως η συνάντηση με έναν άλλο παθιασμένο οικοδεσπότη, κάποιον που μοιράζεται τις αξίες φιλοξενίας σας. Η ανταλλαγή ήταν πάντα κοινωνική πρακτική πριν γίνει οικονομική.",
      share: "Μοιραστείτε τις εμπειρίες σας",
      tips: "Ανταλλάξτε τα καλύτερα κόλπα σας",
      friendship: "Δημιουργήστε μακροχρόνιες φιλίες",
      badge: "Κοινότητα οικοδεσποτών",
      badgeSub: "Αυθεντικές συναντήσεις",
      step2Title: "2. Φιλικό συμβόλαιο στο DONKEY TRAVEL",
      step2Desc:
        "Υπογράφουν το συμβόλαιο ανταλλαγής απευθείας στην πλατφόρμα και λαμβάνουν το PDF με email. Όλα είναι ασφαλή και επίσημα.",
      contractSigned: "Συμβόλαιο υπογεγραμμένο και ασφαλές",
      step3Title: "3. Η Μαρία φτάνει στο Παρίσι (2 εβδομάδες αργότερα)",
      step3Desc:
        "Ο Γιάννης υποδέχεται τη Μαρία θερμά. Είναι εντυπωσιασμένος: το διαμέρισμα είναι άψογο, η Μαρία σέβεται τα πάντα. Τι διαφορά με ορισμένους ταξιδιώτες Airbnb! Συζητούν τις εμπειρίες τους ως οικοδεσπότες πίνοντας καφέ.",
      step4Title: "4. Ο Γιάννης ανακαλύπτει τη Ρεμς (6 μήνες αργότερα)",
      step4Desc:
        "Ο Γιάννης φτάνει στο εξοχικό της Μαρίας στη Ρεμς. Το τοπίο είναι υπέροχο! Η Μαρία τον καλεί για δείπνο, τρώνε μαζί και συζητούν για ταξίδια, την Airbnb και τις καλύτερες ιστορίες τους.",
      step5Title: "5. Μια μακροχρόνια φιλία",
      step5Desc:
        "Η Μαρία και ο Γιάννης μένουν σε επαφή. Αποφασίζουν να ανταλλάσσουν τακτικά τα σπίτια τους. Περισσότερο από μια απλή ανταλλαγή, είναι μια πραγματική φιλία που γεννήθηκε χάρη στο TRAVELTROK.",
      spiritTitle: "Αυτό είναι το πνεύμα του DONKEY TRAVEL!",
      spiritDesc:
        "Αυθεντικές ανταλλαγές μεταξύ παθιασμένων ιδιοκτητών, με σεβασμό και φιλικότητα. Όχι πόντοι, όχι τριγωνισμός, μόνο πραγματική παλιά καλή ανταλλαγή.",
    },
    negotiation: {
      badge: "Διασκεδαστική διαπραγμάτευση",
      title: "Διαπραγματευτείτε σαν παιχνίδι!",
      description:
        "10 νύχτες για 5; Γιατί όχι! Κάντε μια προσφορά, λάβετε μια αντι-προσφορά, βρείτε μια συμφωνία. Όλα σε καλό κλίμα. Όπως τον καιρό των πρώτων ανταλλαγών, η διαπραγμάτευση είναι μέρος της διασκέδασης.",
      marieProperty: "Εξοχικό στη Ρεμς",
      jeanProperty: "Διαμέρισμα στο Παρίσι",
      marieLocation: "Στο εξοχικό της στη Ρεμς",
      jeanLocation: "Στο διαμέρισμά του στο Παρίσι",
      marieAccepts: "Η Μαρία αποδέχεται την προσφορά",
      offers: "Προσφορά",
      proposes: "Προτείνει",
      nights: "νύχτες",
      status: {
        initial: "Η Μαρία κάνει μια προσφορά...",
        counter: "Ο Γιάννης κάνει μια αντι-προσφορά!",
        negotiate: "Η Μαρία διαπραγματεύεται...",
        deal: "Συμφωνία έκλεισε! 🎉",
      },
      chat: {
        msg1: "Σου προτείνω {{marieNights}} νύχτες στο εξοχικό μου στη Ρεμς για {{jeanNights}} νύχτες στο Παρίσι!",
        msg2: "Ο Γιάννης βρίσκει το κατάλυμα της Μαρίας πολύ ωραίο...",
        msg3: "Το εξοχικό σου είναι υπέροχο! Είμαι καλός, σου προτείνω {{jeanNights}} νύχτες στο Παρίσι 😊",
        msg4: "Έγινε! 🤝",
        msg5: "Η Μαρία κοιτάζει τις διαθεσιμότητες του Γιάννη...",
      },
      nextStep: "Επόμενο βήμα",
      restart: "Επανεκκίνηση",
      points: {
        flexible: "Ευέλικτη διαπραγμάτευση",
        friendly: "Φιλική ατμόσφαιρα",
        fair: "Δίκαιη συμφωνία",
      },
    },
    flexibility: {
      title: "Απόλυτη ευελιξία",
      description:
        "Σε αντίθεση με τις παραδοσιακές ανταλλαγές, δεν χρειάζεται να βρείτε κάποιον που θέλει το σπίτι σας ακριβώς όταν θέλετε το δικό του. Συσσωρεύστε Νύχτες και χρησιμοποιήστε τα όποτε θέλετε!",
    },
    example: {
      person1: "Μαρία",
      location1: "Παρίσι, Γαλλία",
      person2: "Γιάννης",
      location2: "Λυών, Γαλλία",
      result: "Επιτυχής ανταλλαγή!",
    },
  },
  exchange: {
    title: "Πώς λειτουργεί;",
    subtitle:
      "Ένα απλό και ασφαλές σύστημα για την εμπιστευτική ανταλλαγή των καταλυμάτων σας",
    features: {
      secure: {
        title: "Ασφαλείς ανταλλαγές",
        description:
          "Όλα τα μέλη επαληθεύονται και οι κριτικές εγγυώνται τη διαφάνεια κάθε ανταλλαγής.",
      },
      sync: {
        title: "Συγχρονισμός ημερολογίου",
        description:
          "Συγχρονίστε αυτόματα τις διαθεσιμότητές σας με το υπάρχον ημερολόγιο Airbnb.",
      },
      global: {
        title: "Ευρωπαϊκό δίκτυο",
        description:
          "Αποκτήστε πρόσβαση σε μέλη-οικοδεσπότες στις διαθέσιμες ευρωπαϊκές χώρες στο TRAVELTROK.",
      },
      chat: {
        title: "Ενσωματωμένα μηνύματα",
        description:
          "Επικοινωνήστε απευθείας με άλλους ιδιοκτήτες για να οργανώσετε τις ανταλλαγές σας.",
      },
      rating: {
        title: "Σύστημα αξιολόγησης",
        description:
          "Δείτε κριτικές και βαθμολογίες για να επιλέξετε τους συνεργάτες ανταλλαγής με εμπιστοσύνη.",
      },
      savings: {
        title: "Εγγυημένη εξοικονόμηση",
        description:
          "Ταξιδέψτε δωρεάν χρησιμοποιώντας τα Νύχτες σας αντί να πληρώνετε ακριβά καταλύματα.",
      },
    },
    steps: {
      title: "Σε 3 απλά βήματα",
      step1: {
        title: "Δημιουργήστε το προφίλ σας",
        description:
          "Εγγραφείτε και προσθέστε πληροφορίες για το κατάλυμά σας Airbnb σε λίγα λεπτά.",
      },
      step2: {
        title: "Βρείτε τον προορισμό σας",
        description:
          "Περιηγηθείτε στα διαθέσιμα καταλύματα και βρείτε τον προορισμό των ονείρων σας.",
      },
      step3: {
        title: "Ανταλλάξτε και ταξιδέψτε",
        description:
          "Προτείνετε μια ανταλλαγή, επιβεβαιώστε τις ημερομηνίες και απολαύστε τη διαμονή σας δωρεάν!",
      },
    },
  },
  worldMap: {
    title: "Top 20 πιο ενεργών χωρών",
    subtitle:
      "Ανακαλύψτε τις χώρες όπου οι ανταλλαγές κατοικιών είναι πιο δημοφιλείς σήμερα",
    description:
      "Η κοινότητά μας μεγαλώνει κάθε μέρα με νέους ιδιοκτήτες σε όλο τον κόσμο. Ανακαλύψτε πού θα μπορούσατε να ταξιδέψετε δωρεάν.",
    badge: "Κατάταξη σε πραγματικό χρόνο",
    properties: "καταλύματα",
    cta: "Δείτε όλους τους προορισμούς",
    exchangesToday: "Ανταλλαγές σήμερα",
    activeCountries: "Ενεργές χώρες",
    vsYesterday: "έναντι χθες",
    fullRanking: "Πλήρης κατάταξη",
    countries: {
      Guadeloupe: "Γουαδελούπη",
      Martinique: "Μαρτινίκα",
      Guyane: "Γαλλική Γουιάνα",
      "La Réunion": "Ρεϋνιόν",
      Mayotte: "Μαγιότ",
      "Polynésie française": "Γαλλική Πολυνησία",
      "Nouvelle-Calédonie": "Νέα Καληδονία",
      "Îles Canaries": "Κανάρια Νησιά",
      "Ceuta & Melilla": "Θέουτα & Μελίγια",
      Madère: "Μαδέρα",
      Açores: "Αζόρες",
      Aruba: "Αρούμπα",
      Curaçao: "Κουρασάο",
      "Saint-Martin": "Άγιος Μαρτίνος",
      Bermudes: "Βερμούδες",
      "Îles Caïmans": "Νησιά Κέιμαν",
      Gibraltar: "Γιβραλτάρ",
      france: "Γαλλία",
      spain: "Ισπανία",
      italy: "Ιταλία",
      usa: "Ηνωμένες Πολιτείες",
      uk: "Ηνωμένο Βασίλειο",
      germany: "Γερμανία",
      portugal: "Πορτογαλία",
      netherlands: "Ολλανδία",
      canada: "Καναδάς",
      australia: "Αυστραλία",
      belgium: "Βέλγιο",
      switzerland: "Ελβετία",
      greece: "Ελλάδα",
      mexico: "Μεξικό",
      brazil: "Βραζιλία",
      austria: "Αυστρία",
      croatia: "Κροατία",
      thailand: "Ταϊλάνδη",
      morocco: "Μαρόκο",
    },
  },
  calendar: {
    title: "Αυτόματος συγχρονισμός με Airbnb",
    subtitle: "Συνδέστε το ημερολόγιο Airbnb με ένα κλικ",
    description:
      "Οι διαθεσιμότητές σας συγχρονίζονται αυτόματα. Δεν χρειάζεται πια να διαχειρίζεστε δύο ημερολόγια ξεχωριστά.",
    features: {
      sync: {
        title: "Αμφίδρομος συγχρονισμός",
        description:
          "Τα ημερολόγιά σας Airbnb και DONKEY TRAVEL παραμένουν πάντα ενημερωμένα αυτόματα",
      },
      realtime: {
        title: "Ενημερώσεις σε πραγματικό χρόνο",
        description:
          "Κάθε τροποποίηση συγχρονίζεται άμεσα και στις δύο πλατφόρμες",
      },
      smart: {
        title: "Έξυπνη διαχείριση",
        description:
          "Αποφύγετε τις διπλοκρατήσεις χάρη στο προηγμένο σύστημα συγχρονισμού μας",
      },
    },
    cta: "Σύνδεση ημερολογίου",
  },
  airbnb: {
    title: "Είστε ήδη οικοδεσπότης Airbnb;",
    subtitle: "Γίνετε μέλος του DONKEY TRAVEL και αρχίστε να ταξιδεύετε δωρεάν",
    description:
      "Εισαγάγετε αυτόματα τις πληροφορίες του καταλύματός σας Airbnb και ξεκινήστε τις ανταλλαγές σήμερα.",
    features: {
      verification: {
        title: "Αυτόματη επαλήθευση του προφίλ σας",
      },
      import: {
        title: "Εισαγωγή φωτογραφιών και περιγραφών",
      },
      trust: {
        title: "Γίνετε μέλος μιας κοινότητας εμπιστοσύνης",
      },
    },
    cta: "Σύνδεση με Airbnb",
  },
  membersMap: {
    title: "Χάρτης Μελών",
    searchPlaceholder: "Αναζήτηση προορισμού, πόλης...",
    filters: "Φίλτρα",
    radius: "Ακτίνα",
    radiusAuto: "Αυτόματα",
    reset: "Επαναφορά",
    filterPets: "Κατοικίδια δεκτά",
    filterVerified: "Επαληθευμένοι οικοδεσπότες",
    filterRating: "4.8+",
    filterAllTypes: "Όλοι οι τύποι",
    oneTraveler: "1 ταξιδιώτης",
    multipleTravelers: "{{count}} ταξιδιώτες",
    dates: "Ημερομηνίες",
    addDates: "Προσθήκη ημερομηνιών",
    startDate: "Άφιξη",
    endDate: "Αναχώρηση",
    listingsTitle: "Καταλύματα",
    listingsSubtitle: "Επιλέξτε για προβολή στο χάρτη.",
    pagination: "{{current}} / {{total}}",
    clearFilters: "Καθαρισμός φίλτρων",
    guestsShort: "άτ.",
    bedroomsShort: "υπν.",
    surfaceAreaUnit: "τ.μ.",
    perNight: "/ νύχτα",
    online: "Συνδεδεμένος",
    offline: "Αποσυνδεδεμένος",
    verified: "Επαληθευμένος",
    favorite: "Αγαπημένο",
    favorites: "Αγαπημένα",
    members: "Μέλη",
    exchanges: "ανταλλαγές",
    rooms: "δωμάτια",
    mapTitle: "Διαδραστικός χάρτης μελών DONKEY TRAVEL",
    countries: "Χώρες",
    results: "αποτελέσματα",
    viewProfile: "Προβολή προφίλ",
    proposeExchange: "Πρόταση ανταλλαγής",
    showFavoritesOnly: "Προβολή μόνο αγαπημένων",
    advancedSearch: "Σύνθετη αναζήτηση",
    refineSearch: "Βελτιώστε την αναζήτησή σας",
    activeFilter: "ενεργό φίλτρο",
    activeFilters: "ενεργά φίλτρα",
    availabilityDates: "Ημερομηνίες διαθεσιμότητας",
    quickPeriods: "Γρήγορες περίοδοι",
    thisMonth: "Αυτόν τον μήνα",
    nextMonth: "Επόμενος μήνας",
    next3Months: "Επόμενοι 3 μήνες",
    summer: "Καλοκαίρι",
    autumn: "Φθινόπωρο",
    winter: "Χειμώνας",
    arrival: "Άφιξη",
    departure: "Αναχώρηση",
    flexibleDates: "Ευέλικτες ημερομηνίες",
    clear: "Καθαρισμός",
    propertyTypeTitle: "Τύπος καταλύματος",
    apartment: "Διαμέρισμα",
    house: "Σπίτι",
    villa: "Βίλα",
    loft: "Λοφτ",
    capacityAndRooms: "Χωρητικότητα & δωμάτια",
    numberOfTravelers: "Αριθμός ταξιδιωτών",
    all: "Όλα",
    numberOfRooms: "Αριθμός δωματίων",
    minimumSurface: "Ελάχιστη επιφάνεια",
    equipments: "Παροχές",
    wifi: "Wi‑Fi",
    pool: "Πισίνα",
    parking: "Πάρκινγκ",
    airConditioning: "Κλιματισμός",
    garden: "Κήπος",
    terrace: "Βεράντα",
    fireplace: "Τζάκι",
    barbecue: "Μπάρμπεκιου",
    bike: "Ποδήλατο",
    sauna: "Σάουνα",
    gym: "Γυμναστήριο",
    washingMachine: "Πλυντήριο",
    statusAvailability: "Κατάσταση & διαθεσιμότητα",
    onlineAvailability: "Διαθεσιμότητα σε σύνδεση",
    onlineOnly: "Μόνο συνδεδεμένοι",
    verifiedMembersOnly: "Μόνο επαληθευμένα μέλη",
    ratingExperience: "Βαθμολογία & εμπειρία",
    minimumRating: "Ελάχιστη βαθμολογία",
    minimumExchanges: "Ελάχιστες ανταλλαγές",
    matchingMembers: "αντίστοιχα μέλη",
    matchingMember: "αντίστοιχο μέλος",
    seeResults: "Δείτε τα",
    result: "αποτέλεσμα",
    resetAllFilters: "Επαναφορά όλων των φίλτρων",
    rating: "Βαθμολογία",
    travelers: "Ταξιδιώτες",
    contact: "Επικοινωνία",
    searchMemberCity: "Αναζήτηση μέλους, πόλης, χώρας...",
    noFavorite: "Κανένα αγαπημένο",
    addFavoritesHint: "Προσθέστε μέλη στα αγαπημένα πατώντας την καρδιά",
    noMemberFound: "Δεν βρέθηκε μέλος",
    tryModifyFilters: "Δοκιμάστε να τροποποιήσετε τα φίλτρα σας",
    viewAllMembers: "Προβολή όλων των μελών",
    modifyFilters: "Τροποποίηση φίλτρων",
    favoritesOnly: "Μόνο αγαπημένα",
    addToFavorites: "Προσθήκη στα αγαπημένα",
    removeFromFavorites: "Αφαίρεση από τα αγαπημένα",
    loading: "Φόρτωση...",
    sortBy: "Ταξινόμηση κατά",
    relevance: "Συνάφεια",
    newest: "Πιο πρόσφατα",
    noResults: "Δεν βρέθηκαν αποτελέσματα",
    tryDifferentFilters: "Δοκιμάστε να προσαρμόσετε τα φίλτρα αναζήτησης",
    membersList: "Λίστα μελών",
    membersFound: "μέλη βρέθηκαν",
    visibleMembers: "Ορατά μέλη",
    legend: "Υπόμνημα",
    availableProperty: "Διαθέσιμο κατάλυμα",
    selected: "Επιλεγμένο",
    visibleByAll: "Ορατό σε όλα",
    allMembersSeeYou: "Όλα τα μέλη σας βλέπουν",
    targetedMode: "Στοχευμένη λειτουργία",
    countriesSelected: "επιλεγμένες χώρες",
    countrySelected: "επιλεγμένη χώρα",
    myVisibility: "Η ορατότητά μου",
    whoCanSee: "Ποιος βλέπει το σπίτι μου στο χάρτη;",
    visibleByAllTitle: "Ορατό σε όλους",
    visibleByAllDesc:
      "Όλα τα μέλη της κοινότητας μπορούν να δουν το σπίτι σας και να προτείνουν ανταλλαγή.",
    visibleByAllHint: "Μέγιστη ορατότητα και ευκαιρίες",
    active: "ΕΝΕΡΓΟ",
    targetedModeTitle: "Στοχευμένη λειτουργία",
    targetedModeDesc:
      "Μόνο τα μέλη των χωρών που αναζητάτε μπορούν να δουν το σπίτι σας. Μέγιστη διακριτικότητα.",
    targetedModeHint: "Βλέπετε και σας βλέπουν μόνο οι επιθυμητοί προορισμοί",
    myDesiredDestinations: "Οι επιθυμητοί προορισμοί μου",
    clearAll: "Καθαρισμός όλων",
    searchCountry: "Αναζήτηση χώρας...",
    member: "μέλος",
    membersCount: "μέλη",
    noCountryFound: "Δεν βρέθηκε χώρα",
    targetedInfoTitle: "Το σπίτι σας εμφανίζεται μόνο σε μέλη από",
    targetedInfoDesc: "Οι υπόλοιποι δεν θα σας βλέπουν στο χάρτη.",
    targetedExample:
      "Παράδειγμα: αν θέλετε να πάτε μόνο Ολλανδία, μόνο οι Ολλανδοί μέλη θα βλέπουν το προφίλ σας.",
    selectAtLeastOneCountry:
      "Επιλέξτε τουλάχιστον μία χώρα για να ενεργοποιήσετε τη στοχευμένη λειτουργία.",
    propertyTypes: {
      appartement: "Διαμέρισμα",
      maison: "Σπίτι",
      villa: "Βίλα",
      loft: "Λοφτ",
      luxe: "Πολυτελές",
      insolite: "Ιδιαίτερο",
    },
    pricePerNight: "ΤΙΜΗ ΑΝΑ ΝΥΧΤΑ (€)",
    min: "Ελάχ",
    max: "Μέγ",
    sortResults: "ΤΑΞΙΝΟΜΗΣΗ ΑΠΟΤΕΛΕΣΜΑΤΩΝ",
    sort: {
      recommended: "✨ Προτεινόμενα",
      priceAsc: "💶 Τιμή αύξουσα",
      priceDesc: "💎 Τιμή φθίνουσα",
    },
    amenitiesTitle: "ΠΑΡΟΧΕΣ",
    amenitiesTabs: {
      all: "ΟΛΑ",
      essentials: "ΒΑΣΙΚΑ",
      features: "ΑΝΕΣΗ",
      location: "ΤΟΠΟΘΕΣΙΑ",
      safety: "ΑΣΦΑΛΕΙΑ",
    },
  },
  amenities: {
    wifi: "Wi-Fi",
    tv: "Τηλεόραση",
    kitchen: "Κουζίνα",
    washing_machine: "Πλυντήριο",
    ac: "Κλιματισμός",
    heating: "Θέρμανση",
    workspace: "Χώρος εργασίας",
    iron: "Σίδερο",
    hair_dryer: "Πιστολάκι μαλλιών",
    pool: "Πισίνα",
    hottub: "Τζακούζι",
    patio: "Βεράντα",
    bbq: "Μπάρμπεκιου",
    parking: "Δωρεάν πάρκινγκ",
    gym: "Γυμναστήριο",
    fireplace: "Τζάκι",
    breakfast: "Πρωινό",
    beachfront: "Παραθαλάσσιο",
    ski_in_out: "Πρόσβαση με σκι",
    lake_access: "Πρόσβαση σε λίμνη",
    smoke_detector: "Ανιχνευτής καπνού",
    first_aid: "Κουτί πρώτων βοηθειών",
    fire_extinguisher: "Πυροσβεστήρας",
  },
  destinations: {
    title: "Προορισμοί",
    searchPlaceholder: "Αναζήτηση προορισμού...",
    destinationsFound: "προορισμοί βρέθηκαν",
    noResults: "Κανένα αποτέλεσμα",
    tryDifferentSearch: "Δοκιμάστε άλλη αναζήτηση",
    sortMembers: "Περισσότερα μέλη",
    sortProperties: "Περισσότερα καταλύματα",
    sortName: "Όνομα (Α-Ω)",
    all: "Όλα",
    members: "μέλη",
    properties: "καταλύματα",
    explore: "Εξερευνήστε αυτόν τον προορισμό",
    stats: {
      destinations: "Προορισμοί",
      members: "Μέλη",
      properties: "Καταλύματα",
      countries: "Χώρες",
    },
    countriesIn: "Χώρες σε",
    selectCountry: "— επιλέξτε χώρα για φιλτράρισμα",
    continents: {
      Europe: "Ευρώπη",
      "Amérique du Nord": "Βόρεια Αμερική",
      "Amérique du Sud": "Νότια Αμερική",
      Asie: "Ασία",
      Afrique: "Αφρική",
      Océanie: "Ωκεανία",
    },
    countries: {
      Turquie: "Τουρκία",
      France: "Γαλλία",
      "Pays-Bas": "Ολλανδία",
      "Royaume-Uni": "Ηνωμένο Βασίλειο",
      Espagne: "Ισπανία",
      Italie: "Ιταλία",
      Tchéquie: "Τσεχία",
      Grèce: "Ελλάδα",
      Portugal: "Πορτογαλία",
      Autriche: "Αυστρία",
      Écosse: "Σκωτία",
      Hongrie: "Ουγγαρία",
      Croatie: "Κροατία",
      Danemark: "Δανία",
      Suède: "Σουηδία",
      Suisse: "Ελβετία",
      Belgique: "Βέλγιο",
      Norvège: "Νορβηγία",
      Irlande: "Ιρλανδία",
      Pologne: "Πολωνία",
      Finlande: "Φινλανδία",
      Islande: "Ισλανδία",
      Roumanie: "Ρουμανία",
      Monténégro: "Μαυροβούνιο",
      "États-Unis": "Ηνωμένες Πολιτείες",
      Canada: "Καναδάς",
      Mexique: "Μεξικό",
      "Costa Rica": "Κόστα Ρίκα",
      Cuba: "Κούβα",
      "Rép. Dominicaine": "Δομινικανή Δημοκρατία",
      Guatemala: "Γουατεμάλα",
      Brésil: "Βραζιλία",
      Argentine: "Αργεντινή",
      Pérou: "Περού",
      Colombie: "Κολομβία",
      Chili: "Χιλή",
      Équateur: "Ισημερινός",
      Uruguay: "Ουρουγουάη",
      Bolivie: "Βολιβία",
      Chine: "Κίνα",
      Thaïlande: "Ταϊλάνδη",
      Indonésie: "Ινδονησία",
      Vietnam: "Βιετνάμ",
      "Corée du Sud": "Νότια Κορέα",
      Inde: "Ινδία",
      Cambodge: "Καμπότζη",
      Jordanie: "Ιορδανία",
      Maldives: "Μαλδίβες",
      "Sri Lanka": "Σρι Λάνκα",
      Népal: "Νεπάλ",
      Philippines: "Φιλιππίνες",
      Ouzbékistan: "Ουζμπεκιστάν",
      Égypte: "Αίγυπτος",
      Maroc: "Μαρόκο",
      "Afrique du Sud": "Νότια Αφρική",
      Tanzanie: "Τανζανία",
      Kenya: "Κένυα",
      Sénégal: "Σενεγάλη",
      Madagascar: "Μαδαγασκάρη",
      Tunisie: "Τυνησία",
      Zimbabwe: "Ζιμπάμπουε",
      Namibie: "Ναμίμπια",
      "Île Maurice": "Μαυρίκιος",
      Rwanda: "Ρουάντα",
      Australie: "Αυστραλία",
      "Nouvelle-Zélande": "Νέα Ζηλανδία",
      "Polynésie française": "Γαλλική Πολυνησία",
      Fidji: "Φίτζι",
      "Nouvelle-Calédonie": "Νέα Καληδονία",
      Samoa: "Σαμόα",
    },
    cities: {
      Paris: "Παρίσι",
      "Mont Saint-Michel": "Μον Σαιν Μισέλ",
      Marseille: "Μασσαλία",
      Amsterdam: "Άμστερνταμ",
      Londres: "Λονδίνο",
      Barcelone: "Βαρκελώνη",
      Madrid: "Μαδρίτη",
      Venise: "Βενετία",
      Rome: "Ρώμη",
      "Côte Amalfitaine": "Ακτή Αμάλφι",
      Prague: "Πράγα",
      Santorin: "Σαντορίνη",
      Athènes: "Αθήνα",
      Lisbonne: "Λισαβόνα",
      Porto: "Πόρτο",
      Vienne: "Βιέννη",
      Édimbourg: "Εδιμβούργο",
      Budapest: "Βουδαπέστη",
      Dubrovnik: "Ντουμπρόβνικ",
      Copenhague: "Κοπεγχάγη",
      Stockholm: "Στοκχόλμη",
      Zermatt: "Ζερμάτ",
      Bruges: "Μπριζ",
      Bergen: "Μπέργκεν",
      Dublin: "Δουβλίνο",
      Cracovie: "Κρακοβία",
      Helsinki: "Ελσίνκι",
      Reykjavik: "Ρέικιαβικ",
      Bucarest: "Βουκουρέστι",
      Kotor: "Κότορ",
      "New York": "Νέα Υόρκη",
      "San Francisco": "Σαν Φρανσίσκο",
      "Los Angeles": "Λος Άντζελες",
      Miami: "Μαϊάμι",
      Hawaï: "Χαβάη",
      Vancouver: "Βανκούβερ",
      Montréal: "Μόντρεαλ",
      Toronto: "Τορόντο",
      Banff: "Μπανφ",
      Québec: "Κεμπέκ",
      Cancún: "Κανκούν",
      "Mexico City": "Πόλη του Μεξικού",
      "San José": "Σαν Χοσέ",
      "La Havane": "Αβάνα",
      "Punta Cana": "Πούντα Κάνα",
      Antigua: "Αντίγκουα",
      "Buenos Aires": "Μπουένος Άιρες",
      "Rio de Janeiro": "Ρίο ντε Τζανέιρο",
      "São Paulo": "Σάο Πάολο",
      "Machu Picchu": "Μάτσου Πίτσου",
      Lima: "Λίμα",
      Carthagène: "Καρθαγένη",
      Bogotá: "Μπογκοτά",
      Santiago: "Σαντιάγο",
      Quito: "Κίτο",
      Montevideo: "Μοντεβιδέο",
      "La Paz": "Λα Παζ",
      Tokyo: "Τόκιο",
      Kyoto: "Κιότο",
      Pékin: "Πεκίνο",
      Shanghai: "Σαγκάη",
      "Hong Kong": "Χονγκ Κονγκ",
      Bangkok: "Μπανγκόκ",
      "Chiang Mai": "Τσιάνγκ Μάι",
      Bali: "Μπαλί",
      "Hô Chi Minh-Ville": "Πόλη Χο Τσι Μινχ",
      Séoul: "Σεούλ",
      "Angkor Wat": "Άνγκορ Βατ",
      Colombo: "Κολόμπο",
      Katmandou: "Κατμαντού",
      Manille: "Μανίλα",
      Samarcande: "Σαμαρκάνδη",
      Petra: "Πέτρα",
      "Le Caire": "Κάιρο",
      Marrakech: "Μαρακές",
      Chefchaouen: "Σεφσαουέν",
      "Le Cap": "Κέιπ Τάουν",
      Johannesburg: "Γιοχάνεσμπουργκ",
      Zanzibar: "Ζανζιβάρη",
      "Safari Masai Mara": "Σαφάρι Μασάι Μάρα",
      Nairobi: "Ναϊρόμπι",
      Dakar: "Ντακάρ",
      Antananarivo: "Ανταναναρίβο",
      Tunis: "Τύνιδα",
      "Chutes Victoria": "Καταρράκτες Βικτωρίας",
      Windhoek: "Βιντχούκ",
      "Île Maurice": "Μαυρίκιος",
      Kigali: "Κιγκάλι",
      Sydney: "Σίδνεϊ",
      Melbourne: "Μελβούρνη",
      "Grande Barrière de Corail": "Μεγάλος Κοράλλινος Ύφαλος",
      Auckland: "Όκλαντ",
      Queenstown: "Κουίνσταουν",
      "Bora Bora": "Μπόρα Μπόρα",
      Fidji: "Φίτζι",
      Nouméa: "Νουμέα",
      Apia: "Άπια",
      "Baie d'Halong": "Κόλπος Χα Λονγκ",
      Maldives: "Μαλδίβες",
    },
  },
  story: {
    badge: "Μια αληθινή ιστορία",
    title: "Μάγια & Λουκ: η τέλεια ανταλλαγή",
    subtitle:
      "Όταν μια Παριζιάνα κουρασμένη από την πόλη συναντά έναν αγρότη που ονειρεύεται το Παρίσι...",
    chloé: {
      aptAlt: "Διαμέρισμα της Μάγια στο Παρίσι",
      quotaExceeded: "Υπέρβαση ορίου Airbnb!",
      role: "Οικοδέσποινα Airbnb στο Παρίσι",
      speech1:
        'Έχω <strong class="text-red-600">ξεπεράσει το όριο των 120 διανυκτερεύσεων</strong>... Αδύνατον να νοικιάσω. Και ειλικρινά, βαρέθηκα τον θόρυβο του Παρισιού. 😩',
      nightsTag: "120/120 νύχτες",
      tiredTag: "Κουρασμένη από το Παρίσι",
      dreamsOf: "Η Μάγια ονειρεύεται...",
      dreamTitle: "Την ηρεμία της εξοχής",
      dreamDesc: "Πράσινο, ησυχία, σάουνα... ο παράδεισος!",
      searching: "Ψάχνει εξοχικό σπίτι",
      findsLuc: "Βρίσκει τον Λουκ!",
      speech2:
        "Επιτέλους ηρεμία! Η σάουνα μετά από μια βόλτα στο δάσος, είναι η <strong>απόλυτη ευτυχία</strong>. 🌿✨",
      review:
        "Το σπίτι του Λουκ είναι ένας μικρός παράδεισος! Η σάουνα μετά από μια βόλτα στο δάσος, είναι η ευτυχία. Γίναμε φίλοι! Το συνιστώ 200%.",
    },
    hugo: {
      giteAlt: "Εξοχικό σπίτι του Λουκ",
      available: "Διαθέσιμο όλο το χρόνο",
      location: "Εξοχή, Γαλλία",
      role: "Οικοδεσπότης Airbnb στην εξοχή",
      speech1:
        'Το σπίτι μου έχει <strong class="text-sage-600">κήπο, σάουνα και καρέκλα μασάζ</strong>... αλλά δεν αντέχω άλλο την εξοχή. Ονειρεύομαι το Παρίσι! 🗼',
      dreamsOf: "Ο Λουκ ονειρεύεται...",
      dreamTitle: "Τα φώτα του Παρισιού",
      dreamDesc: "Τα μουσεία, τα καφέ, τον Πύργο του Άιφελ... επιτέλους!",
      searching: "Ψάχνει διαμέρισμα στο Παρίσι",
      findsMaya: "Βρίσκει τη Μάγια!",
      speech2:
        "Παρίσι, επιτέλους! Το Λούβρο, τα μπιστρό, οι στέγες... είναι <strong>μαγικά</strong>! 🗼🥐",
      review:
        "Το διαμέρισμα της Μάγια είναι απίστευτο, θέα στις στέγες του Παρισιού! Και όλα αυτά χωρίς να αγγίξω το όριό της. Η ανταλλαγή είναι φοβερή!",
    },
    tags: {
      garden: "Κήπος",
      sauna: "Σάουνα",
      massage: "Μασάζ",
      countryside: "Εξοχή",
      bigGarden: "Μεγάλος κήπος",
      restaurants: "Εστιατόρια",
      museums: "Μουσεία",
    },
    match: {
      spark: "Το κλικ!",
      title: "Ανακαλύπτουν το DONKEY TRAVEL",
      perfect: "Τέλειο ταίριασμα!",
    },
    quota: {
      title: "Εκτός ορίου Airbnb = 100% δωρεάν!",
      description:
        "Η διαμονή του Λουκ δεν επηρεάζει το όριο της Μάγια. Είναι ανταλλαγή, όχι ενοικίαση. Όλοι κερδίζουν!",
      totalCost: "Συνολικό κόστος",
      quotaNight: "Νύχτα ορίου",
    },
    happyEnd: {
      title: "Όλοι είναι χαρούμενοι! 🎊",
      subtitle:
        "Η Μάγια και ο Λουκ έγιναν φίλοι. Μοιράζονται τις συμβουλές τους ως οικοδεσπότες και ήδη σχεδιάζουν την επόμενη ανταλλαγή!",
      exchangeSuccess: "Επιτυχής ανταλλαγή",
      newFriendship: "Νέα φιλία",
      outsideQuota: "Εκτός ορίου",
      free: "100% δωρεάν",
    },
  },
  messaging: {
    messages: "Μηνύματα",
    searchPlaceholder: "Αναζήτηση συνομιλίας...",
    all: "Όλα",
    unread: "Μη αναγνωσμένα",
    archived: "Αρχειοθετημένα",
    online: "Συνδεδεμένος",
    offline: "Αποσυνδεδεμένος",
    messagePlaceholder: "Γράψτε ένα μήνυμα...",
    writeMessage: "Γράψτε ένα μήνυμα",
    sending: "Αποστολή...",
    characters: "χαρακτήρες",
    noConversation: "Καμία συνομιλία",
    notificationMessage: "Νέο μήνυμα",
    quickActions: "Γρήγορες ενέργειες",
    proposeExchange: "Πρόταση ανταλλαγής",
    proposeExchangeTitle: "Πρόταση ανταλλαγής",
    checkAvailability: "Έλεγχος διαθεσιμότητας",
    report: "Αναφορά",
    hisProperty: "Το κατάλυμά του",
    rooms: "δωμάτια",
    guests: "ταξιδιώτες",
    verifiedOwner: "Επαληθευμένος ιδιοκτήτης",
    viewAirbnbListing: "Προβολή αγγελίας Airbnb",
    details: "Λεπτομέρειες",
    desiredDates: "Επιθυμητές ημερομηνίες",
    arrival: "Άφιξη",
    departure: "Αναχώρηση",
    period: "Περίοδος",
    duration: "Διάρκεια",
    nights: "νύχτες",
    numberOfTravelers: "Αριθμός ταξιδιωτών",
    traveler: "ταξιδιώτης",
    travelers: "ταξιδιώτες",
    person: "άτομο",
    persons: "άτομα",
    dateFlexibility: "Ευελιξία ημερομηνιών",
    exactDates: "Ακριβείς ημερομηνίες",
    flex1to2: "± 1-2 ημέρες",
    flex3to5: "± 3-5 ημέρες",
    flexWeek: "± 1 εβδομάδα",
    personalMessage: "Προσωπικό μήνυμα",
    summary: "Σύνοψη",
    termsAccept: "Αποδέχομαι τους όρους ανταλλαγής του DONKEY TRAVEL",
    sendProposal: "Αποστολή πρότασης",
    proposalSent: "Η πρόταση εστάλη!",
    proposalSentMessage: "Η πρότασή σας εστάλη με επιτυχία",
    close: "Κλείσιμο",
    today: "Σήμερα",
    selectConversation: "Επιλέξτε μια συνομιλία",
    selectConversationHint:
      "Επιλέξτε έναν ιδιοκτήτη για να ξεκινήσετε τη συνομιλία",
  },
  destination_introuvable: `Ο προορισμός δεν βρέθηκε`,
  cette_destination_n_apos_existe_pas_ou_a__t__d_pla: `Αυτός ο προορισμός δεν υπάρχει ή έχει μετακινηθεί.`,
  retour_aux_destinations: `Επιστροφή στους προορισμούς`,
  pr_t___d_couvrir_: `Έτοιμοι να ανακαλύψετε`,
  r_server_ce_s_jour: `Κάντε κράτηση για αυτήν τη διαμονή`,
  explorer_d_apos_autres_destinations: `Εξερευνήστε άλλους προορισμούς`,
  acc_s_r_serv_: `Δεσμευμένη πρόσβαση`,
  europe_unique: `Ενιαία Ευρώπη`,
  "50eur_an_pour__changer_dans_toute_l_europe_": `50 EUR/έτος για ανταλλαγή σε όλη την Ευρώπη.`,
  lancement_2026: `Έναρξη 2026`,
  club_d__change_h_tes_airbnb: `Airbnb Host Exchange Club`,
  optimisez_vos_p_riodes_creuses_gr_ce_aux__changes: `Βελτιστοποιήστε τις περιόδους εκτός αιχμής χάρη στις ανταλλαγές`,
  rejoindre_le_club: `Εγγραφείτε στο κλαμπ`,
  trouver_un_h_te: `Βρείτε έναν οικοδεσπότη`,
  r_serv__aux_h_tes_traveltrok: `Κρατήθηκε για επισκέπτες του DONKEY TRAVEL`,
  voyagez_gratuitement_gr_ce___votre_logement: `Ταξιδέψτε δωρεάν με τη διαμονή σας`,
  accueillez_des_membres_et_faites_vous_accueillir_e: `Καλώς ήρθατε στα μέλη και σας καλωσορίζουμε ξανά. Μια απλή, άμεση και χωρίς μετρητά ανταλλαγή μεταξύ των ιδιοκτητών.`,
  devenir_h_te: `Γίνετε οικοδεσπότης`,
  comment__a_marche__: `Πώς λειτουργεί;`,
  amis_partageant_un_repas_en_corse: `Φίλοι που μοιράζονται ένα γεύμα στην Κορσική`,
  _nous_avons__chang__notre_maison___lyon_contre_une: `"Αναλλάξαμε το σπίτι μας στη Λυών με μια βίλα στην Κορσική. Κόστος: 0€."`,
  sophie___marc__membres_depuis_2023: `Sophie & Marc, μέλη από το 2023`,
  pas_de_monnaie__pas_de_points__juste_un_accord_ent: `Χωρίς κέρματα, χωρίς πόντους. Απλά μια συμφωνία μεταξύ δύο ιδιοκτητών. Έρχομαι σπίτι σου, εσύ έλα σπίτι μου.`,
  "1__accord_mutuel": `1. Αμοιβαία συμφωνία`,
  vous_trouvez_un_membre_qui_vous_pla_t_et_vous_vous: `Βρίσκετε ένα μέλος που σας αρέσει και συμφωνείτε να ανταλλάξετε καταλύματα.`,
  "2__flexibilit__totale": `2. Απόλυτη ευελιξία`,
  "3__z_ro_comptabilit_": `3. Μηδενική λογιστική`,
  pas_de_points___compter__juste_le_plaisir_de_parta: `Δεν υπάρχουν βαθμοί για μέτρηση. Μόνο η ευχαρίστηση του μοιράσματος και της συνάντησης.`,
  pourquoi_les_h_tes_adorent_ce_syst_me__: `Γιατί οι οικοδεσπότες αγαπούν αυτό το σύστημα;`,
  plus_qu__une__conomie__c__est_une_nouvelle_fa_on_d: `Περισσότερο από οικονομία, είναι ένας νέος τρόπος ταξιδιού.`,
  "0__de_frais": `0€ αμοιβές`,
  les__changes_sont_totalement_gratuits__pas_de_frai: `Οι ανταλλαγές είναι εντελώς δωρεάν. Χωρίς χρέωση υπηρεσιών, χωρίς τέλη καθαρισμού (εκτός εάν έχει συμφωνηθεί ειδικά).`,
  confiance_totale: `Απόλυτη εμπιστοσύνη`,
  seuls_les_h_tes_v_rifi_s_peuvent__changer__vous_ac: `Μόνο επαληθευμένοι οικοδεσπότες μπορούν να κάνουν συναλλαγές. Καλωσορίζετε κάποιον που γνωρίζει την αξία της στέγασης.`,
  simplicit_: `Απλότητα`,
  oubliez_la_valeur_des_points__une_nuit_est_une_nui: `Ξεχάστε την αξία των πόντων. Μια νύχτα είναι μια νύχτα. Η ανταλλαγή βασίζεται στην εμπιστοσύνη μεταξύ των οικοδεσποτών.`,
  rejoignez_la_communaut__des_h_tes: `Εγγραφείτε στην κοινότητα υποδοχής`,
  rejoignez_la_communaut__et_commencez____changer_: `Γίνετε μέλος της κοινότητας και ξεκινήστε τη συνομιλία.`,
  commencer_maintenant: `Ξεκινήστε τώρα`,
  pr_nom_invalide: `Μη έγκυρο όνομα`,
  nom_invalide: `Μη έγκυρο όνομα`,
  email_invalide: `Μη έγκυρο email`,
  s_lectionne_un_pays: `Επιλέξτε χώρα`,
  s_lectionne_un_mode_tarifaire: `Επιλέξτε μια μέθοδο τιμολόγησης`,
  s_lectionne_ton_usage: `Επιλέξτε τη χρήση σας`,
  tu_dois_accepter_les_conditions: `Πρέπει να αποδεχτείτε τους όρους`,
  france: `Γαλλία`,
  belgique: `Βέλγιο`,
  suisse: `Ελβετία`,
  canada: `Καναδάς`,
  allemagne: `Γερμανία`,
  espagne: `Ισπανία`,
  italie: `Ιταλία`,
  portugal: `Πορτογαλία`,
  royaume_uni: `Ηνωμένο Βασίλειο`,
  _tats_unis: `Ηνωμένες Πολιτείες`,
  autre: `Άλλα`,
  merci_de_corriger_les_champs_en_erreur_: `Διορθώστε τα εσφαλμένα πεδία.`,
  une_erreur_est_survenue__r_essaie_dans_quelques_in: `Παρουσιάστηκε σφάλμα. Δοκιμάστε ξανά σε λίγα λεπτά.`,
  compte_cr___avec_succ_s: `Ο λογαριασμός δημιουργήθηκε με επιτυχία`,
  tu_recevras_un_email_pour_finaliser_ton_profil_voy: `Θα λάβετε ένα email για να οριστικοποιήσετε το προφίλ ταξιδιώτη/οικοδεσπότη σας.`,
  cr_er_un_autre_compte: `Δημιουργία άλλου λογαριασμού`,
  activation_traveltrok: `Ενεργοποίηση DONKEY TRAVEL`,
  choisis_ton_mode__voyageur__h_te__ou_usage_mixte_: `Επιλέξτε τη λειτουργία σας: ταξιδιώτης, οικοδεσπότης ή μικτή χρήση.`,
  pr_nom: `Όνομα`,
  jeanne: `Τζέιν`,
  nom: `Όνομα`,
  durand: `Ντουράντ`,
  email: `Email`,
  jeanne_email_com: `jeanne@email.com`,
  t_l_phone__optionnel_: `Τηλέφωνο (προαιρετικό)`,
  pays: `Χώρα`,
  choisir_un_pays: `Επιλέξτε χώρα`,
  mode_tarifaire: `Μέθοδος τιμολόγησης`,
  voyageur: `Ταξιδιώτης`,
  nuit: `νύχτα`,
  h_te: `οικοδεσπότης`,
  pro_multi_logements: `Pro πολυκατοικία`,
  mois: `μήνας`,
  usage_principal: `Κύρια χρήση`,
  je_voyage_principalement: `Κυρίως ταξιδεύω`,
  je_loue_principalement: `νοικιάζω κυρίως`,
  je_fais_les_deux: `κάνω και τα δύο`,
  nombre_de_logements: `Αριθμός καταλυμάτων`,
  logement: `διαμονή`,
  logements: `διαμονή`,
  a: `α`,
  j_accepte_les_conditions_d_utilisation_et_la_polit: `Αποδέχομαι τους όρους χρήσης και την πολιτική απορρήτου.`,
  cr_ation_en_cours___: `Η δημιουργία σε εξέλιξη...`,
  cr_er_mon_compte_traveltrok: `Δημιουργία λογαριασμού DONKEY TRAVEL`,
  r_servation_de_logements: `Κράτηση καταλύματος`,
  support_h_te_prioritaire: `Υποστήριξη κεντρικού υπολογιστή προτεραιότητας`,
  carte___filtres_avanc_s: `Χάρτης + προηγμένα φίλτρα`,
  flux_de_r_servation__tape_par__tape: `Βήμα προς βήμα ροή κρατήσεων`,
  couverture_dommages_assistance: `Κάλυψη ζημιών/βοήθειας`,
  multi_logements___reporting: `Πολυκατοικία + αναφορά`,
  accueil: `Αρχική σελίδα`,
  tarifs: `Τιμές`,
  "0__commission_pour_les_h_tes": `Προμήθεια 0% για οικοδεσπότες`,
  r_volution_traveltrok: `DONKEY TRAVEL Επανάσταση`,
  gardez_100__de_ce_que_vous_gagnez: `Κρατήστε το 100% των κερδών σας`,
  simple: `Απλό`,
  tu_connais_ton_co_t_avant_de_r_server__aucun_effet: `Γνωρίζετε το κόστος σας πριν την κράτηση. Δεν υπάρχουν εκπλήξεις κατά την πληρωμή.`,
  honn_te: `Ειλικρινής`,
  le_m_me_principe_pour_tous__voyageur_et_h_te_sont_: `Η ίδια αρχή για όλους: ο ταξιδιώτης και ο οικοδεσπότης αντιμετωπίζονται με τον ίδιο κανόνα.`,
  utile: `Χρήσιμο`,
  je_suis_voyageur: `Είμαι ταξιδιώτης`,
  je_suis_h_te: `Είμαι οικοδεσπότης`,
  j_ai_plusieurs_logements: `Έχω πολλά καταλύματα`,
  simulateur_comparatif_host: `Συγκριτικός προσομοιωτής κεντρικού υπολογιστή`,
  compare_booking__airbnb_et_traveltrok_avec_tes_pro: `Συγκρίνετε Booking, Airbnb και DONKEY TRAVEL με τα δικά σας στοιχεία.`,
  nombre_de_nuits: `Αριθμός διανυκτερεύσεων`,
  property_price___night__eur_: `Τιμή ακινήτου / διανυκτέρευση (EUR)`,
  autres_frais__m_nage__accueil__linge_____eur: `Άλλα έξοδα (καθαρισμός, υποδοχή, λευκά είδη κ.λπ.) EUR`,
  option___qui_paie_les_frais__5____: `Επιλογή: Ποιος πληρώνει τα τέλη (5%);`,
  standard__recommand__: `Τυπικό (Συνιστάται)`,
  pro___attractivit_: `Επαγγελματική / Ελκυστικότητα`,
  le_voyageur_paie_5__en_plus__vous_touchez_100__du_: `Ο ταξιδιώτης πληρώνει 5% περισσότερο. Λαμβάνετε το 100% της τιμής.`,
  vous_payez_les_5___le_prix_affich__au_voyageur_est: `Πληρώνετε το 5%. Η τιμή που εμφανίζεται στον ταξιδιώτη είναι καθαρή.`,
  base_de_calcul: `Βάση υπολογισμού`,
  nuit_s_: `νύχτα(ες)`,
  autres_frais: `Λοιπά έξοδα`,
  montant_total_avant_commissions: `Συνολικό ποσό πριν από τις προμήθειες`,
  plateforme: `Πλατφόρμα`,
  frais_h_te: `Χρεώσεις φιλοξενίας`,
  frais_voyageur: `Ταξιδιωτικές αμοιβές`,
  total_voyageur: `Σύνολο ταξιδιώτη`,
  net_h_te: `Net host`,
  avantage_fiscal___pro: `Tax & Pro Advantage`,
  consultez_votre_expert_comptable_: `Συμβουλευτείτε τον λογιστή σας.`,
  diff_rence_h_te__claire_et_vendeuse: `Διαφορά κεντρικού υπολογιστή: καθαρή και πώληση`,
  frais_h_te___an: `Χρεώσεις φιλοξενίας / έτος`,
  _conomie_compar_e___booking: `Οικονομία σε σύγκριση με Κράτηση`,
  _conomie_vs_airbnb: `Οικονομία εναντίον Airbnb`,
  exemple_typique_sur_1_an__h_te_: `Τυπικό παράδειγμα άνω του 1 έτους (οικοδεσπότης)`,
  nuits_r_serv_es: `Νύχτες κρατημένες`,
  s_jours___an: `Διαμονή / έτος`,
  chiffre_d_affaires_annuel: `Ετήσιος κύκλος εργασι��ν`,
  frais_traveltrok: `Τέλη DONKEY TRAVEL`,
  frais_booking__15__: `Τέλη κράτησης (15%)`,
  frais_airbnb__15_5__: `Τέλη Airbnb (15,5%)`,
  net_h_te_traveltrok: `Net host DONKEY TRAVEL`,
  comparatif_des_modes: `Σύγκριση τρόπων`,
  ce_que_tu_actives_selon_ton_usage_traveltrok_: `Τι ενεργοποιείτε ανάλογα με τη χρήση του TRAVELTROK.`,
  fonction: `Λειτουργία`,
  pro: `Pro`,
  cr_er_ton_compte_et_ton_mode_d_usage: `Δημιουργήστε τον λογαριασμό σας και τον τρόπο χρήσης σας`,
  choisis_si_tu_d_marres_en_voyageur__h_te__ou_les_d: `Επιλέξτε αν θα ξεκινήσετε ως ταξιδιώτης, οικοδεσπότης ή και τα δύο. Μπορείτε να αλλάξετε ανά πάσα στιγμή.`,
  location_simple_c_t__voyageur: `Ενοικίαση μονής στην πλευρά του συνοδηγού`,
  recherche__filtres__r_servation_rapide_et_co_t_tra: `Αναζήτηση, φίλτρα, γρήγορη κράτηση και διαφανές κόστος.`,
  gestion_h_te_simplifi_e: `Απλοποιημένη διαχείριση κεντρικού υπολογιστή`,
  publie_ton_logement__g_re_ton_calendrier_et_r_pond: `Δημοσιεύστε τη διαμονή σας, διαχειριστείτε το ημερολόγιό σας και απαντήστε γρήγορα σε αιτήματα.`,
  couverture_incluse_pour_le_voyageur_et_pour_l_h_te: `Περιλαμβάνεται κάλυψη για τον ταξιδιώτη και τον οικοδεσπότη.`,
  support_op_rationnel: `Λειτουργική υποστήριξη`,
  accompagnement_en_cas_de_litige__annulation_ou_bes: `Υποστήριξη σε περίπτωση διαφωνίας, ακύρωσης ή ανάγκης διαμεσολάβησης.`,
  faq_tarifs: `Τιμές FAQ`,
  vraiment_0__de_commission_pour_l_h_te__: `Αλήθεια 0% προμήθεια για τον οικοδεσπότη;`,
  oui__l_h_te_re_oit_100__du_prix_qu_il_fixe__aucun_: `Ναί. Ο οικοδεσπότης λαμβάνει το 100% της τιμής που ορίζει. Χωρίς τέλη εξυπηρέτησης, χωρίς τέλη επεξεργασίας.`,
  combien_paie_le_voyageur__: `Πόσα πληρώνει ο ταξιδιώτης;`,
  le_voyageur_paie_une_commission_de_5__sur_le_monta: `Ο ταξιδιώτης πληρώνει προμήθεια 5% επί του ποσού ενοικίασης. Αυτό καλύπτει λειτουργικά έξοδα, ασφάλιση και υποστήριξη.`,
  puis_je__changer_mon_logement_gratuitement__: `Μπορώ να ανταλλάξω τη διαμονή μου δωρεάν;`,
  oui___si_vous__tes_h_te__vous_pouvez__changer_votr: `Ναι ! Εάν είστε οικοδεσπότης, μπορείτε να ανταλλάξετε τη διαμονή σας με άλλα μέλη χωρίς καμία χρέωση (0€).`,
  pourquoi_ce_mod_le_est_il_moins_cher__: `Γιατί είναι φθηνότερο αυτό το μοντέλο;`,
  en_ne_prenant_que_5__au_total__contre_15____20__ai: `Λαμβάνοντας μόνο 5% συνολικά (σε σύγκριση με 15% έως 20% αλλού), κάνουμε τα ταξίδια πιο προσιτά, ενώ πληρώνουμε καλύτερα τους οικοδεσπότες.`,
  pr_t___activer_ton_mode_traveltrok__: `Είστε έτοιμοι να ενεργοποιήσετε τη λειτουργία DONKEY TRAVEL;`,
  voyageur__h_te__ou_hybride__commence_avec_une_logi: `Ταξιδιώτης, οικοδεσπότης ή υβριδικό: ξεκινά με σαφή λογική και ελεγχόμενο κόστος.`,
  cr_er_mon_compte: `Δημιουργία λογαριασμού`,
  explorer_les_logements: `Εξερευνήστε καταλύματα`,
  donn_es_personnelles: `Προσωπικά δεδομένα`,
  politique_de_confidentialit_: `Πολιτική Απορρήτου`,
  rejoignez_notre_communaut__et_r_servez_un_logement: `Εγγραφείτε στην κοινότητά μας και κάντε κράτηση διαμονής στο {{city}} με σαφείς σταθερές χρεώσεις και ασφάλιση.`,
  une_plateforme_d__changes_europ_enne_r_serv_e_aux_: `Μια ευρωπαϊκή πλατφόρμα ανταλλαγής που προορίζεται για οικοδεσπότες Airbnb`,
  club_priv__pour_h_tes_not_s_4_5____un_abonnement_u: `Ιδιωτικό κλαμπ για επισκέπτες με βαθμολογία 4,5+: μια μοναδική συνδρομή για ανταλλαγή σε όλη την Ευρώπη.`,
  r_serv__aux_h_tes_airbnb_avec_une_note_sup_rieure_: `Κρατήθηκε για οικοδεσπότες Airbnb με βαθμολογία μεγαλύτερη ή ίση με 4,5.`,
  r_duction_de_50__en_2026__25eur_an_au_lieu_de_50eu: `Μείωση 50% το 2026: 25 ευρώ/έτος αντί για 50 ευρώ/έτος. Τιμή εγγυημένη εφ' όρου ζωής για τις πρώτες 1000 εγγραφές.`,
  basse_saison__pause__rencontres_entre_h_tes__conom: `Χαμηλή περίοδος, διαλείμματα, συναντήσεις μεταξύ επισκεπτών, εξοικονόμηση πόρων για διακοπές: όλα είναι σχεδιασμένα για ενεργούς επισκέπτες στην Ευρώπη.`,
  voyagez_moins_cher__5__de_frais___h_bergez_sans_fr: `Ταξιδέψτε φθηνότερα (5% χρεώσεις), φιλοξενήστε δωρεάν (0%). Το πιο δίκαιο μοντέλο της αγοράς.`,
  fini_les_commissions_de_15__ou_plus__avec_traveltr: `Όχι άλλες προμήθειες 15% ή περισσότερο. Με το DONKEY TRAVEL, οι οικοδεσπότες δεν πληρώνουν τέλη. Οι ταξιδι��τες πληρώνουν μόνο 5% χρέωση υπηρεσιών. Αυτό είναι δικαιοσύνη.`,
  hypoth_se_comparatif__booking_commission_h_te_15__: `Συγκριτική υπόθεση: Προμήθεια οικοδεσπότη κράτησης 15% (ανάλογα με τη χώρα και το πρόγραμμα), λειτουργία μόνο για φιλοξενία Airbnb στο 15,5% στην πλευρά του οικοδεσπότη και 0 στην πλευρά του ταξιδιώτη.`,
  les_frais_de_5__peuvent__tre_d_ductibles_de_vos_ch: `Το τέλος 5% μπορεί να αφαιρεθεί από τα έξοδά σας εάν είστε εταιρεία. Το μοντέλο 0% απλοποιεί την προσωπική λογιστική.`,
  avec_traveltrok__vous_pouvez_baisser_le_prix_de_vo: `Με το DONKEY TRAVEL, μπορείτε να μειώσετε την τιμή των ενοικίων σας για να νοικιάσετε πιο συχνά. Οι χρεώσεις φιλοξενίας παραμένουν σταθερές, επομένως το δίχτυ σας παραμένει ισχυρό.`,
  en_moyenne__c_est_environ___annualhostcase_average: `Κατά μέσο όρο, είναι περίπου {{savings}}} ευρώ σε ετήσια εξοικονόμηση σε σύγκριση με πλατφόρμες που βασίζονται σε προμήθειες.`,
  hypoth_ses__100eur_la_nuit__30eur_de_m_nage__dur_e: `Υποθέσεις: 100 EUR ανά διανυκτέρευση, 30 EUR καθαρισμός, μέση διάρκεια 3 διανυκτερεύσεις, 50% ετήσια τιμή κράτησης.`,
  traveltrok_collecte_uniquement_les_donn_es_n_cessa: `Το DONKEY TRAVEL συλ��έγει μόνο τα δεδομένα που είναι απαραίτητα για τη λειτουργία της υπηρεσίας: λογαριασμό, προφίλ, ανταλλαγές και υποστήριξη.`,
  vos_donn_es_ne_sont_partag_es_qu_avec_les_services: `Τα δεδομένα σας κοινοποιούνται μόνο σε βασικές τεχνικές υπηρεσίες (έλεγχος ταυτότητας, φιλοξενία, ασφάλεια) και δεν μεταπωλούνται ποτέ.`,
  vous_pouvez_demander_la_mise___jour_ou_la_suppress: `Μπορείτε να ζητήσετε να ενημερώσετε ή να διαγράψετε τα προσωπικά σας δεδομένα από τον λογαριασμό σας ή επικοινωνώντας με την υποστήριξη.`,
  "help.faq.q1.question": "Πόσο κοστίζει η συνδρομή;",
  "help.faq.q1.answer":
    "50€/έτος για το κλασικό πλάνο. Υπάρχει έκπτωση γνωριμίας 25€/έτος για το 2026.",
  "help.faq.q2.question":
    "Μπορώ να κάνω ανταλλαγή χωρίς να έχω τις ίδιες ημερομηνίες;",
  "help.faq.q2.answer":
    "Απολύτως. Το ευέλικτο σύστημα ανταλλαγής επιτρέπει στον οικοδεσπότη 1 να πάει στον οικοδεσπότη 2 τον Ιούλιο, και στον οικοδεσπότη 2 να έρθει στον οικοδεσπότη 1 τον Σεπτέμβριο, ασύγχρονα.",
  "help.faq.q3.question":
    "Είναι πραγματικά αποκλειστικό για οικοδεσπότες με βαθμολογία 4.5 και άνω το site;",
  "help.faq.q3.answer":
    "Ναι. Το Donkey Travel είναι ένα κλειστό club. Κατά την εγγραφή σας, ελέγχουμε το link για την καταχώρισή σας στο Airbnb, για να βεβαιωθούμε ότι η μέση βαθμολογία σας είναι τουλάχιστον 4.5/5 και ότι έχετε κριτικές.",
  "help.faq.q4.question": "Πώς οργανώνονται οι ανταλλαγές;",
  "help.faq.q4.answer":
    "Δεν υπάρχει σύστημα βαθμολογίας. Τα μέλη αποφασίζουν τα ίδια πόσες διανυκτερεύσεις θέλουν να ανταλλάξουν με βάση την τιμή που αναφέρουν. Η καταχώριση Airbnb χρησιμεύει ως αναφορά για να ελεγχθεί εάν η πρόταση είναι δίκαιη και αξιόπιστη.",
  "help.faq.q5.question":
    "Υπάρχουν πρόσθετες χρεώσεις (καθαρισμός, εξυπηρέτηση);",
  "help.faq.q5.answer":
    "Όχι! Η αρχή του Donkey Travel είναι 100% δωρεάν ανταλλαγή μεταξύ των οικοδεσποτών. Ο οικοδεσπότης υποδοχής προετοιμάζει το κατάλυμα, και ο φιλοξενούμενος το επιστρέφει σε μια άψογα καθαρή κατάσταση (ή το διαχειρίζεται με τον οικοδεσπότη της συνεργασίας τους).",
  "help.faq.q6.question": "Μπορώ να συνδέσω πολλαπλές καταχωρίσεις Airbnb;",
  "help.faq.q6.answer":
    "Ναι, αυτό σχεδιάζεται για τις επερχόμενες ενημερώσεις μας ώστε να σας επιτρέψουμε να συγχρονίσετε πολλά καταλύματα και να έχετε ακόμη περισσότερες ευκαιρίες για ανταλλαγή.",
  "help.faq.q7.question": "Τι γίνεται αν μια ανταλλαγή ακυρωθεί;",
  "help.faq.q7.answer":
    "Σε περίπτωση ακύρωσης, σας προσκαλούμε να επικοινωνήσετε με τον οικοδεσπότη σας μέσω των εσωτερικών μας μηνυμάτων για να βρείτε μια νέα συμφωνία ή νέες ημερομηνίες.",
  "help.faq.q8.question": "Πώς εγγυώνται η εμπιστοσύνη και η ασφάλεια;",
  "help.faq.q8.answer":
    "Με το να αποδεχόμαστε μόνο επιβεβαιωμένους οικοδεσπότες (βαθμολογία > 4.5), φροντίζουμε η κοινότητά να γνωρίζει τι σημαίνει το να είσαι 'οικοδεσπότης'. Επιπλέον, το πρόσωπο και οι καταχωρίσεις επαληθεύονται από την ομάδα μας.",
};
